import React, { Fragment, useState, useEffect } from "react";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  usePagination,
  useSortBy,
  useGlobalFilter,
  useRowSelect,
} from "react-table";
import Pagination from "react-bootstrap/Pagination";
import { matchSorter } from "match-sorter";
import InputGroup from "react-bootstrap/InputGroup";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import useTokenCheck from "../../hooks/useTokenCheck";

const Styles = styled.div`
  padding: 1rem;
  table {
    flex: 1;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    border-spacing: 0;
    min-height: 50vh;
    tr {
      display: flex;
      flex-wrap: nowrap;
      :first-child {
        td {
          // border-bottom: 0;
        }
      }
    }
    th,
    td {
      flex: 1;
      flex-wrap: nowrap;
      margin: 0;
      padding: 0.5rem;
      border-bottom: 1px solid black;
      //   border-right: 1px solid black;
      input {
        width: 95%;
      }
      :last-child {
        border-right: 0;
        margin-right: 0.5rem;
        align-item: center;
      }
    }
  }
`;
// Create a default prop getter
const defaultPropGetter = () => ({});

// Define a default UI for filtering
function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
  label,
  setIsFiltered,
}) {
  return (
    <input
      aria-label={"Filter by " + label}
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
        setIsFiltered(" ");
      }}
    />
  );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
  return matchSorter(rows, filterValue.toLowerCase(), {
    keys: [(row) => row.values[id]?.toString()?.toLowerCase()],
  });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Create an editable cell renderer
const EditableCell = ({
  value: initialValue,
  row,
  column: { id },
  updateFieldData, // This is a custom function that we supplied to our table instance
  enableEdit,
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);
  const [editable, setEditable] = React.useState(false);
  const { index } = row;

  const onChange = (e) => {
    setValue(e.target.value);
    updateFieldData(index, id, value);
  };

  // We'll only update the external data when the input is blurred
  // const onBlur = () => {
  //   updateFieldData(index, id, value);
  // };

  // If the initialValue is changed external, sync it up with our state
  React.useEffect(() => {
    // setValue(initialValue ? "" : initialValue);
    console.log("CHANGE ROWWW");
    setEditable(enableEdit(index, id, value));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [row]);

  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  // React.useEffect(() => {
  //   setValue(initialValue ? "" : initialValue);
  //   setEditable(enableEdit(index, id, value));
  // }, [editable]);
  // React.useEffect(() => {
  //   console.log(`ROWWWW ${index} ${row[id]}`);
  // }, [row]);

  return (
    <input
      value={value}
      onChange={onChange}
      placeholder="$0.00"
      disabled={editable}
    />
  );
};

// Create an editable cell renderer
const ActionCell = (props) => {
  const { hasTokenExpired } = useTokenCheck();
  const {
    value: initialValue,
    row: { index },
    column: { id, onClickAction, fieldType, actionClassName, actionName },
  } = props;
  const onClick = async (e) => {
    await hasTokenExpired();
    e.preventDefault();
    onClickAction(index, id, initialValue);
  };

  return (
    <Fragment>
      {fieldType === "button" ? (
        <input
          type="button"
          className={actionClassName}
          onClick={onClick}
          value={actionName ? actionName : initialValue}
        ></input>
      ) : (
        <button
          className={actionClassName ? actionClassName : "drillColumn"}
          onClick={onClick}
          tabIndex="0"
          id={props.id}
        >
          {actionName ? actionName : initialValue}
        </button>
      )}
    </Fragment>
  );
};

// Set the editable cell renderer for the  Cell renderer
const editableColumn = {
  editableCell: EditableCell,
};

const actionColumn = {
  actionCell: ActionCell,
};

// Define a default UI for filtering
function GlobalFilter({
  preGlobalFilteredRows,
  globalFilter,
  setGlobalFilter,
  setIsFiltered,
}) {
  // const count = preGlobalFilteredRows.length;
  const [value, setValue] = React.useState("");
  // const onChange = useAsyncDebounce((value) => {
  //   setGlobalFilter(value || undefined);
  // }, 200);
  const onSearch = () => {
    setGlobalFilter(value || "");
    console.log(" Master Data:", preGlobalFilteredRows);
    setIsFiltered(`Filtered table by ${value}`);
  };

  useEffect(() => {
    console.log("Global Filter value : ", value);
    console.log("Actual Global Filter value : ", globalFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    console.log("##Global Filter value : ", value);
    console.log("##Actual Global Filter value : ", globalFilter);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter]);

  return (
    <div className="patronPage__searchBar">
      <InputGroup className="mb-3">
        <FormControl
          name="searchText"
          id="searchText"
          placeholder="Search here"
          aria-label="Search group name or group details"
          value={value || ""}
          onChange={(e) => {
            setValue(e.target.value);
            // onChange(e.target.value);
          }}
          role="search"
        />
        <Button
          variant="primary"
          id="searchButton"
          aria-label="Search"
          onClick={onSearch}
        >
          <i className="fas fa-search"></i>
        </Button>
      </InputGroup>
    </div>
  );
}

const IndeterminateCheckbox = React.forwardRef(
  ({ id, indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
      if (
        resolvedRef.current.title === "Toggle All Current Page Rows Selected"
      ) {
        resolvedRef.current.title = " ";
      } else {
        console.log("employeeId", rest.row);
        if (rest?.row?.values) {
          const keys = Object.keys(rest?.row?.values);
          const value = rest?.row?.values[keys[0]];
          resolvedRef.current.title = `Toggle Select Row for ${rest?.row?.cells[1].column.Header} ${value}`;
        }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resolvedRef, indeterminate]);

    const onChangeState = (e) => {
      console.log("e.key", e.key, rest.onChange);
      if (e.key === "Enter") {
        e.target.checked = !e.target.checked;
        rest.onChange(e);
      }
    };

    return (
      <>
        <input
          type="checkbox"
          onKeyDown={(e) => onChangeState(e)}
          ref={resolvedRef}
          aria-checked={resolvedRef.current?.checked ? "true" : "false"}
          {...rest}
          {...(id && { id: id })}
        />
      </>
    );
  }
);

function Table({
  columns,
  data,
  getHeaderProps = defaultPropGetter,
  getColumnProps = defaultPropGetter,
  getRowProps = defaultPropGetter,
  getCellProps = defaultPropGetter,
  updateFieldData,
  enableEdit,
  skipPageReset,
  turnOffFilter,
  enableGlobalFilter,
  enableRowSelect,
  pages,
  pageSize,
  loadPageData,
  tableAction,
  onTableAction,
}) {
  // const filterTypes = React.useMemo(
  //   () => ({
  //     // Add a new fuzzyTextFilterFn filter type.
  //     fuzzyText: fuzzyTextFilterFn,
  //     // Or, override the default text filter to use
  //     // "startWith"
  //     text: (rows, id, filterValue) => {
  //       return rows.filter((row) => {
  //         const rowValue = row.values[id];
  //         return rowValue !== undefined
  //           ? String(rowValue)
  //               .toLowerCase()
  //               .includes(String(filterValue).toLowerCase())
  //           : true;
  //       });
  //     },
  //   }),
  //   []
  // );

  const globalFilter = (rows, ids, filterValue) => {
    // console.log("$$$Filter ids:", ids);
    // console.log("$$$Filter Rows:", rows);
    // // console.log("$$$Filter Rows:", flatRows);
    return rows.filter((row) => {
      let hasMatch = false;
      ids.forEach((colId) => {
        // console.log("$$$Col:", colId);
        if (colId !== "selection" && !hasMatch) {
          const rowValue = row.values[colId];
          // console.log("$$$rowval:", rowValue);
          hasMatch =
            rowValue !== undefined && rowValue !== null
              ? String(rowValue)
                  .toLowerCase()
                  .includes(String(filterValue).toLowerCase())
              : false;
        }
      });
      return hasMatch;
    });
    // return rows.filter(row => {
    //   const rowValue = row.values[id];
    //   return rowValue !== undefined
    //     ? String(rowValue)
    //         .toLowerCase()
    //         .startsWith(String(filterValue).toLowerCase())
    //     : true;
    // });
  };
  // const customGlobalFilter = React.useMemo(
  //   //rows: Array<Row>, columnIds: Array<ColumnId: String>, globalFilterValue
  //   (data, columnIds, globalFilterValue) => data[0],
  //   []
  // );
  const defaultColumn = React.useMemo(
    () => ({
      Filter: DefaultColumnFilter,
      editableCell: EditableCell,
      actionCell: ActionCell,
    }),
    []
  );

  const getCellType = (cellType) => {
    return cellType === "editable" ? "editableCell" : "actionCell";
  };

  const getCellStyle = (cellType) => {
    return cellType === "editable"
      ? {
          fontWeight: "bolder",
        }
      : "";
  };
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    headerGroups,
    page,
    prepareRow,
    pageCount,
    gotoPage,
    state: { pageIndex, selectedRowIds },
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns,
      data,
      defaultColumn,
      editableColumn,
      actionColumn,
      initialState: { pageIndex: 0, pageSize: 25 },
      // manualGlobalFilter: true,
      globalFilter,
      // filterTypes,
      autoResetPage: !skipPageReset,
      updateFieldData,
      turnOffFilter,
      // globalFilter: customGlobalFilter,
      enableGlobalFilter,
      enableRowSelect,
      enableEdit,
      getCellType,
      getCellStyle,
      tableAction,
      onTableAction,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      if (enableRowSelect) {
        hooks.visibleColumns.push((columns) => [
          {
            id: "selection",
            Header: ({ getToggleAllPageRowsSelectedProps }) => (
              <Fragment>
                <div className="tableHeader__top__checkbox">
                  <label htmlFor="SelectAll">Select </label>
                  <span class="sr-only">All</span>
                  <IndeterminateCheckbox
                    aria-label="Toggle All Rows"
                    {...getToggleAllPageRowsSelectedProps()}
                    id="SelectAll"
                  />
                </div>
              </Fragment>
            ),
            Cell: ({ row }) => (
              <div style={{ padding: "0 2rem" }}>
                <IndeterminateCheckbox
                  {...row.getToggleRowSelectedProps()}
                  row={row}
                />
              </div>
            ),
          },
          ...columns,
        ]);
      }
    }
  );
  const { hasTokenExpired } = useTokenCheck();
  const loadPage = async (pageNo) => {
    if (pageNo !== currentPage) {
      if (pages) {
        await loadPageData(pageNo);
      } else {
        gotoPage(pageNo);
      }
      setCurrentPage(pageNo);
    }
  };

  const [currentPage, setCurrentPage] = useState(0);
  const [showPageSet, setShowPageSet] = useState(0);
  const numberOfPages = pages ? pages.numberOfPages : pageCount;
  // const currentPage = pages ? pages.pageNumber : pageIndex;
  const pageSetSize = pages && pages.pageSetSize ? pages.pageSetSize : 10;
  const currentPageSetIndex = parseInt(currentPage / pageSetSize) + 1;
  const lastPageSetIndex = parseInt(numberOfPages / pageSetSize) + 1;
  const enablePreviousPage = currentPage > 0;
  const enableNextPage = currentPage < numberOfPages - 1;
  const enablePreviousPageSet = showPageSet - 1 > 0;
  const enableNextPageSet = showPageSet < lastPageSetIndex - 1;
  // console.log("#numberOfPages", numberOfPages);
  // console.log("#currentPage", currentPage);
  // console.log("#enablePreviousPage", enablePreviousPage);
  // console.log("#enableNextPage", enableNextPage);
  const gotoPreviousPage = async () => {
    await hasTokenExpired();
    loadPage(currentPage - 1);
  };
  const gotoNextPage = async () => {
    await hasTokenExpired();
    loadPage(currentPage + 1);
  };
  const gotoPreviousPageSet = async () => {
    await hasTokenExpired();
    setShowPageSet(showPageSet - 1);
  };
  const gotoNextPageSet = async () => {
    await hasTokenExpired();
    setShowPageSet(showPageSet + 1);
  };

  const pageItem = (index) => (
    <Pagination.Item
      key={index}
      onClick={() => loadPage(index)}
      active={currentPage === index}
      activeLabel=""
    >
      {index + 1}
    </Pagination.Item>
  );

  const getCurrentPageNumber = (index, pageSet) =>
    ((pageSet ? pageSet : currentPageSetIndex) - 1) * pageSetSize +
    (index % pageSetSize);

  const lastPageSetSize =
    lastPageSetIndex === currentPageSetIndex
      ? numberOfPages % pageSetSize
      : pageSetSize;
  console.log("lastPageSetSize ", lastPageSetSize);
  console.log("currentPageSetIndex ", currentPageSetIndex);
  console.log("lastPageSetIndex ", lastPageSetIndex);

  // const [pageNumbers, setPageNumbers] = useState([]);

  React.useEffect(() => {
    setCurrentPage(pages ? pages.pageNumber : pageIndex);
    // setShowPageSet(currentPageSetIndex);
    // setPageNumbers(buildPagination());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageIndex, pages]);

  React.useEffect(() => {
    console.log("@@@Current Page ", currentPage);
    setShowPageSet(currentPageSetIndex);
    setIsFiltered(
      `The table data is refreshed for the page ${currentPage + 1}`
    );
    // setPageNumbers(buildPagination());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage]);

  // React.useEffect(() => {
  //   setCurrentPage(pages ? pages.pageNumber : pageIndex);
  //   // setPageNumbers(buildPagination());
  // }, [showPageSet]);

  const buildPagination = (pageSet) => {
    // if (pageNumbers.length > 0) return pageNumbers;
    let rows = [];
    rows.push(pageItem(0));
    if (numberOfPages > pageSetSize)
      rows.push(
        <Pagination.Ellipsis
          onClick={() => gotoPreviousPageSet()}
          disabled={!enablePreviousPageSet}
        />
      );
    for (let i = 0; i < lastPageSetSize; i++) {
      const pageNumber = getCurrentPageNumber(i, pageSet);
      if (!(pageNumber === 0 || pageNumber === numberOfPages - 1)) {
        console.log("pageNumber ", pageNumber);
        rows.push(pageItem(pageNumber));
      }
    }
    if (numberOfPages > pageSetSize)
      rows.push(
        <Pagination.Ellipsis
          onClick={() => gotoNextPageSet()}
          disabled={!enableNextPageSet}
        />
      );
    rows.push(pageItem(numberOfPages - 1));
    return rows;
  };

  const [isFiltered, setIsFiltered] = useState(" ");
  const [sortBy, setSortBy] = useState();
  const [filteredState, setFilteredState] = useState();
  console.log("isFiltered", isFiltered);

  const objectsEqual = (o1, o2) =>
    Object.keys(o1).length === Object.keys(o2).length &&
    Object.keys(o1).every((p) => o1[p] === o2[p]);

  const arraysEqual = (a1, a2) =>
    a1?.length === a2?.length && a1.every((o, idx) => objectsEqual(o, a2[idx]));

  const checkObj = (a, b) => a.value == b.value && a.value == b.value;

  const filteredBy = (a, b) =>
    a && b && a.filter((aObj) => !b.some((bObj) => checkObj(aObj, bObj)));

  React.useEffect(() => {
    console.log("stateChange-->", state);
    if (
      state.sortBy.length >= 0 &&
      JSON.stringify(sortBy) !== JSON.stringify(state.sortBy[0])
    ) {
      console.log("stateChange sort");
      setSortBy(state.sortBy[0]);
      if (state.sortBy[0]?.id) {
        const sortOrder = state.sortBy[0]?.desc ? "descending" : "ascending";
        setIsFiltered(`Sorted in ${sortOrder} order by ${state.sortBy[0]?.id}`);
      }
      // else {
      //   setIsFiltered(" ");
      // }
    } else if (
      state.filters.length > 0 &&
      !arraysEqual(state.filters, filteredState)
    ) {
      console.log(
        " stateChange filteredBy",
        filteredBy(state.filters, filteredState)
      );
      let tableFiltered;
      if (filteredState) {
        if (filteredBy(state.filters, filteredState)) {
          if (filteredBy(state.filters, filteredState).length > 0) {
            setFilteredState(state.filters);
            tableFiltered = filteredBy(state.filters, filteredState);
            setIsFiltered(
              `Filtered column ${tableFiltered[0].id}  by ${tableFiltered[0].value}`
            );
          }
        }
      } else {
        setFilteredState(state.filters);
        tableFiltered = state.filters;
        setIsFiltered(
          `Filtered column ${tableFiltered[0].id}  by ${tableFiltered[0].value}`
        );
      }
      // const tableFiltered = filteredBy(state.filters, filteredState)
      //   ? filteredBy(state.filters, filteredState)
      //   : state.filters;
      // setFilteredState(state.filters);
      // } else if (
      //   filteredState &&
      //   filteredState.length > 0 &&
      //   state.filters.length === 0
      // ) {
      //   console.log(
      //     "stateChange filteredState ",
      //     filteredState,
      //     filteredState.length > 0,
      //     state.filters.length === 0
      //   );
      //   setFilteredState(state.filters);
      //   setIsFiltered(" ");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  // console.log("------------------------>page", page);
  // Render the UI for your table
  return (
    <Fragment>
      {enableGlobalFilter && (
        <GlobalFilter
          preGlobalFilteredRows={preGlobalFilteredRows}
          globalFilter={state.globalFilter}
          setGlobalFilter={setGlobalFilter}
          setIsFiltered={setIsFiltered}
        />
      )}
      {isFiltered && (
        <div aria-live="polite" style={{ color: "transparent", height: "1px" }}>
          {isFiltered}
        </div>
      )}
      <div className="responsive-table table-container">
        <table className="responsive-table_container" {...getTableProps()}>
          {headerGroups.map((headerGroup) => (
            <tr
              className="responsive-table_row responsive-table-header patronPage__tableListing__header"
              {...headerGroup.getHeaderGroupProps()}
            >
              {headerGroup.headers.map((column, index) => (
                <th
                  className="responsive-table-cell tableHeader"
                  scope="col"
                  aria-describedby={column.id}
                  {...(column.canSort &&
                    column.fieldType !== "button" && {
                      "aria-sort": column.isSorted
                        ? column.isSortedDesc
                          ? "descending"
                          : "ascending"
                        : "none",
                    })}
                >
                  {/* <div
                    className="tableHeader"
                    // {...column.getHeaderProps([
                    //   getColumnProps(column),
                    //   getHeaderProps(column),
                    // ])}
                  > */}
                  <div
                    {...column.getHeaderProps([
                      column.fieldType !== "button" &&
                        column.getSortByToggleProps(),
                      getColumnProps(column),
                      getHeaderProps(column),
                    ])}
                    className="tableHeader__top"
                  >
                    {column.canSort && column.fieldType !== "button" ? (
                      <button
                        className="tableHeaderText"
                        onClick={(e) => {
                          e.preventDefault();
                          column.getHeaderProps([
                            column.getSortByToggleProps(),
                          ]);
                        }}
                        id={column.id}
                      >
                        {column.render("Header")}
                      </button>
                    ) : (
                      <div className="tableHeaderText" id={column.id}>
                        {column.render("Header")}
                      </div>
                    )}
                    <Fragment>
                      <div
                        // {...column.getHeaderProps([
                        //   column.getSortByToggleProps(),
                        // ])}
                        className="tableHeader__sort"
                        aria-hidden="true"
                      >
                        {column.isSorted
                          ? column.isSortedDesc
                            ? "🔽"
                            : "🔼"
                          : column.canSort &&
                            column.fieldType !== "button" &&
                            "🔽🔼"}
                      </div>
                    </Fragment>
                  </div>
                  {!turnOffFilter && (
                    <div className="tableHeader__filter">
                      {column.canFilter && column.fieldType !== "button"
                        ? column.render("Filter", {
                            label: column.Header,
                            setIsFiltered: setIsFiltered,
                          })
                        : null}
                    </div>
                  )}
                  {/* </div> */}
                </th>
              ))}
            </tr>
          ))}

          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr
                className="responsive-table_row"
                {...row.getRowProps(getRowProps(row))}
              >
                {row.cells.map((cell) => {
                  if (cell.column.id === Object.keys(cell.row.values)[0]) {
                    return (
                      <th
                        className="responsive-table-cell"
                        {...cell.getCellProps([
                          {
                            className: cell.column.className,
                            style: cell.column.style,
                          },
                          getColumnProps(cell.column),
                          getCellProps(cell),
                        ])}
                        scope="row"
                        aria-label={
                          Object.keys(row.cells[0].row.values)[0] +
                          " " +
                          Object.values(row.cells[0].row.values)[0]
                        }
                      >
                        {cell.column.customCell
                          ? cell.render(getCellType(cell.column.customCell), {
                              id:
                                cell.column.id ===
                                  Object.keys(cell.row.values)[0] &&
                                Object.values(cell.row.values)[0],
                            })
                          : cell.render("Cell", {
                              id:
                                cell.column.id ===
                                  Object.keys(cell.row.values)[0] &&
                                Object.values(cell.row.values)[0],
                            })}
                      </th>
                    );
                  } else {
                    return (
                      <td
                        className="responsive-table-cell"
                        {...cell.getCellProps([
                          {
                            className: cell.column.className,
                            style: cell.column.style,
                          },
                          getColumnProps(cell.column),
                          getCellProps(cell),
                        ])}
                      >
                        {cell.column.customCell
                          ? cell.render(getCellType(cell.column.customCell), {
                              id:
                                cell.column.id ===
                                  Object.keys(cell.row.values)[0] &&
                                Object.keys(cell.row.values)[0],
                            })
                          : cell.render("Cell", {
                              id:
                                cell.column.id ===
                                  Object.keys(cell.row.values)[0] &&
                                Object.keys(cell.row.values)[0],
                            })}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          })}
        </table>
      </div>
      {/* <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr style={{width:"min-content"}}
              {...headerGroup.getHeaderGroupProps()}
              className="patronPage__tableListing__header"
            >
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps([
                    getColumnProps(column),
                    getHeaderProps(column),
                  ])}
                  className="tableHeader"
                >
                  <div className="tableHeader__top">
                    <div className="tableHeaderText">
                      {column.render("Header")}
                    </div>
                    {!turnOffFilter && (
                      <Fragment>
                        <div
                          {...column.getHeaderProps([
                            column.getSortByToggleProps(),
                          ])}
                          className="tableHeader__sort"
                        >
                          {column.isSorted
                            ? column.isSortedDesc
                              ? "🔽"
                              : "🔼"
                            : ""}
                        </div>
                      </Fragment>
                    )}
                  </div>
                  {!turnOffFilter && (
                    <div className="tableHeader__filter">
                      {column.canFilter ? column.render("Filter") : null}
                    </div>
                  )}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row)
            return (
              <tr className="table-row" {...row.getRowProps(getRowProps(row))}>
                {row.cells.map((cell) => {
                  return (
                    <td
                      className="table-cell"
                      {...cell.getCellProps([
                        {
                          className: cell.column.className,
                          style: cell.column.style,
                        },
                        getColumnProps(cell.column),
                        getCellProps(cell),
                      ])}
                    >
                      {cell.column.customCell
                        ? cell.render(getCellType(cell.column.customCell))
                        : cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table> */}
      <div className={tableAction ? "tableFooter" : "tableFooter__right"}>
        {tableAction && (
          <input
            type="button"
            className="tableBottomAction btn-primary"
            value={tableAction}
            onClick={async (e) => {
              await hasTokenExpired();
              e.preventDefault();
              onTableAction(selectedRowIds);
            }}
            disabled={!Object.keys(selectedRowIds).length}
          ></input>
        )}
        {numberOfPages > 1 && (
          <Pagination role="navigation" aria-label="pagination">
            <Pagination.First
              onClick={() => loadPage(0)}
              disabled={!enablePreviousPage}
            />
            <Pagination.Prev
              onClick={() => gotoPreviousPage()}
              disabled={!enablePreviousPage}
            />
            {buildPagination(showPageSet)}
            <Pagination.Next
              onClick={() => gotoNextPage()}
              disabled={!enableNextPage}
            />
            <Pagination.Last
              onClick={() => loadPage(numberOfPages - 1)}
              disabled={!enableNextPage}
            />
          </Pagination>
        )}
      </div>
    </Fragment>
  );
}

function DataTable(props) {
  const columns = props.columnDefs;
  const data = props.data;

  // const data = React.useMemo(() => props.data, [props.data]);
  // const [currentData, setCurrentData] = React.useState(() => data, [data]);
  // // const [originalData] = React.useState(data);
  // const [skipPageReset, setSkipPageReset] = React.useState(false);

  // const updateFieldData = async (rowIndex, columnId, value) => {
  //   // We also turn on the flag to not reset the page
  //   setSkipPageReset(true);
  //   await setCurrentData((old) =>
  //     old.map((row, index) => {
  //       if (index === rowIndex) {
  //         return {
  //           ...old[rowIndex],
  //           [columnId]: value,
  //         };
  //       }
  //       return row;
  //     })
  //   );
  //   props.updateChangedData(currentData);
  // };

  // React.useEffect(() => {
  //   if (props.updateChangedData) {
  //     setSkipPageReset(false);
  //     props.updateChangedData(currentData);
  //   }
  // }, [currentData]);

  // React.useEffect(() => {
  //   setCurrentData(data);
  //   // props.updateChangedData(currentData);
  // }, [data]);

  const {
    pages,
    pageSize,
    loadPageData,
    tableAction,
    onTableAction,
    turnOffFilter,
    enableGlobalFilter,
    enableRowSelect,
  } = props;

  return (
    <Styles>
      <Table
        columns={columns}
        data={data}
        pages={pages}
        pageSize={pageSize}
        loadPageData={loadPageData}
        tableAction={tableAction}
        onTableAction={onTableAction}
        turnOffFilter={turnOffFilter}
        enableGlobalFilter={enableGlobalFilter}
        enableRowSelect={enableRowSelect}
        skipPageReset={props.skipPageReset}
        getRowProps={(row) => ({
          style: {
            background: row.index % 2 === 0 ? "rgba(0,0,0,.1)" : "white",
          },
        })}
      />
    </Styles>
  );
}

export default DataTable;
